// @flow

import React, { useContext } from 'react';
import { useFormikContext } from 'formik';

import { ESTIMATE_COMMIT_DETAILS_CONFIG_MAP } from '../../configuration/estimate-commit-details';
import {
  CC_STARTER_COMMIT_NONE,
  CC_STARTER_COMMIT_TOOLTIP_TEXT,
  CC_STARTER_COMMIT_TYPE_BACKEND_NAME,
  CC_STARTER_COMMIT_TYPE_LABELS,
  DEAL_TYPE_BACKEND_NAME,
  DEAL_TYPE_NEW_COMMIT,
  SUPPORT_TIER_BACKEND_NAME,
  SUPPORT_TIER_DEVELOPER,
  SUPPORT_TIER_FREE,
} from '../../constants';
import { SelectField } from '../../formik-utils/FormFields';
import { EstimateContext } from '../../contexts/EstimateContext';
import { Tooltip } from '../presentational/Tooltip';
import { setFieldValueToGivenStringAndFieldTouchedToTrue } from '../../formik-utils/utils';

export const CCStarterCommitContainer = () => {
  const estimateData = useContext(EstimateContext);
  const { values, setFieldValue, setFieldTouched } = useFormikContext();

  // Backend rejects a package unless Deal Type = New Commit (no admin override), so don't offer it.
  const isPackageAllowed = values[DEAL_TYPE_BACKEND_NAME] === DEAL_TYPE_NEW_COMMIT;
  const ccStarterCommitPlans = estimateData?.commit_config?.cc_starter_commit_types ?? [];
  const options = ccStarterCommitPlans.map((value) => ({
    name: value,
    display_name: CC_STARTER_COMMIT_TYPE_LABELS[value] ?? value,
    shouldNotBeSelectable: value !== CC_STARTER_COMMIT_NONE && !isPackageAllowed,
  }));
  const config = ESTIMATE_COMMIT_DETAILS_CONFIG_MAP.get(CC_STARTER_COMMIT_TYPE_BACKEND_NAME);

  return (
    <SelectField
      fieldDisplayName={config.displayName}
      fieldName={config.backendFieldName}
      onChange={async (_, newValue) => {
        // Only Free is actually invalid alongside a package (backend rejects it unconditionally,
        // see estimate_service.go) - Business/Premier/Developer are all valid, so a deliberate
        // existing choice there is left untouched. Free can't normally be selected once a package
        // is active (see SupportTiersContainer's filtering), but can still be the inherited value
        // from before the toggle was switched on, which is exactly the case this defaults away from.
        if (
          newValue !== CC_STARTER_COMMIT_NONE &&
          values[SUPPORT_TIER_BACKEND_NAME] === SUPPORT_TIER_FREE
        ) {
          await setFieldValueToGivenStringAndFieldTouchedToTrue(
            SUPPORT_TIER_BACKEND_NAME,
            SUPPORT_TIER_DEVELOPER,
            setFieldValue,
            setFieldTouched
          );
        }
      }}
      options={options}
      tooltip={<Tooltip text={CC_STARTER_COMMIT_TOOLTIP_TEXT} />}
    />
  );
};
